

import '../../../scss-core/abstracts/_abstracts.scss';
import "./scss/_large-screen-navigation.scss";
import "./scss/_small-screen-navigation.scss";
import "./scss/_shop-categories.scss";

$(function () {
	//PRIMARY LARGE SCREEN NAVIGATION
	if ($("#primary-large-screen-navigation").length > 0) {
		//HANDLE SUBMENUS
		$("#primary-large-screen-navigation")
			.find(".menu-item-has-children")
			.hover(
				function () {
					$(this).find("ul").fadeIn();
				},
				function () {
					$(this).find("ul").fadeOut();
				}
			);
		//END HANDLE SUBMENUS
	}
	//END PRIMARY LARGE SCREEN NAVIGATION
});

//NAVIGATIONAL ICONS

//END NAVIGATIONAL ICONS

